import { AppContextType, CapitalType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";
import { DateType } from "../../../../static/types/commonTypes/dateType";
import CapitalChange from "../../../commonComponents/CapitalChange";
import DateComponent from "../../../commonComponents/DateComponent";
import { useEffect, useMemo } from "react";

const ChangeShareCapital = () => {

    const {

        socialCapitalChange,
        setSocialCapitalChange,

        socialCapitalChangeEffectiveDate,
        setSocialCapitalChangeEffectiveDate,
        setSocialCapitalChangeEffectiveDateValidity,
        socialCapitalChangeEffectiveDateChecked,

        oldCapitalChange,
        setOldCapitalChange,
        setOldCapitalChangeValidity,
        oldCapitalChangeChecked,
        
        newCapitalChange,
        setNewCapitalChange,
        setNewCapitalChangeValidity,
        newCapitalChangeChecked,

    } = useAppContext() as AppContextType

    const updateDate = (data: Partial<DateType>) => setSocialCapitalChangeEffectiveDate ({...socialCapitalChangeEffectiveDate, ...data});
    const updateOldCapital = (data: Partial<CapitalType>) => setOldCapitalChange ({...oldCapitalChange, ...data});
    const updateNewCapital = (data: Partial<CapitalType>) => setNewCapitalChange ({...newCapitalChange, ...data});

    // Validation de la cohérence entre ancien et nouveau capital
    const capitalCoherenceValidation = useMemo(() => {
        if (socialCapitalChange === 0) return { isValid: true, message: '' };
        
        const oldValue = oldCapitalChange?.capital || 0;
        const newValue = newCapitalChange?.capital || 0;
        
        if (oldValue === 0 || newValue === 0) {
            return { isValid: false, message: 'Veuillez saisir les montants de l\'ancien et du nouveau capital' };
        }
        
        if (socialCapitalChange === 1) { // Augmentation
            if (newValue <= oldValue) {
                return { 
                    isValid: false, 
                    message: 'Le nouveau capital doit être supérieur à l\'ancien capital pour une augmentation' 
                };
            }
        } else if (socialCapitalChange === 2) { // Diminution
            if (newValue >= oldValue) {
                return { 
                    isValid: false, 
                    message: 'Le nouveau capital doit être inférieur à l\'ancien capital pour une diminution' 
                };
            }
        }
        
        return { isValid: true, message: '' };
    }, [socialCapitalChange, oldCapitalChange?.capital, newCapitalChange?.capital]);

    // Mise à jour des validités en cas de changement de cohérence
    useEffect(() => {
        if (socialCapitalChange !== 0) {
            setOldCapitalChangeValidity(capitalCoherenceValidation.isValid);
            setNewCapitalChangeValidity(capitalCoherenceValidation.isValid);
        }
    }, [capitalCoherenceValidation.isValid, socialCapitalChange, setOldCapitalChangeValidity, setNewCapitalChangeValidity]);

    return (
        <div>
            <div className = 'col-sm-10 d-flex align-items-center mt-1'>
                <label htmlFor = "denomination" className = "col-sm-2 col-form-label mb-0">
                    Modification
                </label>
                <select
                    className = 'form-select w-75'
                    id = "denomination"
                    onChange = {( e ) => setSocialCapitalChange( Number( e.target.value ))}
                    value = {socialCapitalChange }
                >
                    <option value = { 0 }> Aucune modification </option>
                    <option value = { 1 }> Augmentation </option>
                    <option value = { 2 }> Diminution </option>
                </select>
            </div>

            {
                socialCapitalChange !== 0 &&
                <div className = "mt-3">
                    <div className="col-sm-7">
                        <DateComponent
                            id="socialCapitalChangeEffectiveDate"
                            date = { socialCapitalChangeEffectiveDate }
                            draftFieldName = "socialCapitalChangeEffectiveDate"
                            changeDate = { updateDate }
                            dateLabel = "Date d'effet"
                            checked = { socialCapitalChangeEffectiveDateChecked }
                            onValidationChange = {( isValid: boolean ) => setSocialCapitalChangeEffectiveDateValidity( isValid )}
                            required = { false }
                        />
                    </div>
                    
                    <CapitalChange
                        onChange = { updateOldCapital }
                        capital = { oldCapitalChange }
                        fieldKey = "oldCapitalChange"
                        inputLabel = "Ancien"
                        checked = { oldCapitalChangeChecked }
                        onValidationChange = {( isValid: boolean ) => setOldCapitalChangeValidity( isValid )}
                    />
                    <CapitalChange
                        onChange = { updateNewCapital }
                        capital = { newCapitalChange }
                        fieldKey = "newCapitalChange"
                        inputLabel = "Nouveau"
                        checked = { newCapitalChangeChecked }
                        onValidationChange = {( isValid: boolean ) => setNewCapitalChangeValidity( isValid )}
                    />
                    
                    {/* Message d'erreur de cohérence */}
                    {!capitalCoherenceValidation.isValid && (
                        <div className="alert alert-danger mt-2" role="alert">
                            {capitalCoherenceValidation.message}
                        </div>
                    )}
                </div>
            }
        </div>
           
    )
}

export default ChangeShareCapital;